import { defineStore } from "pinia";
import { ref } from "vue";


export const useGlobalStore = defineStore("storeGlobal", () =>
{



  // Build info
  const buildVersion = ref('');
  const buildDate = ref('');

  // Debug
  const showDebug = ref(localStorage.getItem('debug') === 'true');
  const showAuthDebug = ref(localStorage.getItem('authDebug') === 'true');

  // Menu edit
  const editMenu = ref(false);

  // Setter for build info (kalles fra auth.ts)
  function setBuildInfo (version, date) {
    buildVersion.value = version || '';
    buildDate.value = date || '';
  }

  // Eksplisitte actions for å sette debug-flagg
  function setDebug (enabled) {
    showDebug.value = enabled;
    localStorage.setItem('debug', enabled.toString());
  }

  function setAuthDebug (enabled) {
    showAuthDebug.value = enabled;
    localStorage.setItem('authDebug', enabled.toString());
  }

  // Logging helper
  function debug (...args)
  {
    if (showDebug.value) {
      console.debug(...args);
    }
  }

  function authDebug (...args)
  {
    if (showAuthDebug.value) {
      console.debug('[Auth]', ...args);
    }
  }

  return {
    buildVersion,
    buildDate,
    setBuildInfo,
    showDebug,
    showAuthDebug,
    editMenu,
    setDebug,
    setAuthDebug,
    debug,
    authDebug,
  };
});
